<template>
  <article :class="[isSpot ? 'p-4' : 'lg:pt-7vw pb-8 h-full w-full']">
    <div
      v-if="image"
      class="w-full h-64 bg-full mb-8 bg-white-30"
      :style="{ backgroundImage: `url('${image}')` }"
      role="img"
      aria-label="image.alt"
    />

    <div
      class="tiny-mce text-white"
      :class="[isSpot ? '' : 'px-5vw lg:px-0']"
      v-html="post.body"
    />
  </article>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Article',

  props: {
    post: {
      type: Object,
      default: () => {}
    },

    isSpot: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([]),

    image() {
      const image = this.post.image

      if (image && this.mobile) {
        return image.sizes.medium
      } else if (image) {
        return image.sizes.large
      }

      return false
    }
  }
}
</script>
